/*
 * @Author: Teemo Ding
 * @Date: 2021-08-05 17:02:16
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-08-31 16:38:35
 * @FilePath: /unifyxp-v2-store-portal/src/request/customer/database.ts
 */

import { get, post } from 'src/tools/server';

export const request_CustomerDatabaseList = () => {
  return get<any>(`/portal/customerDatabases`, {});
};

export const request_addCustomerDatabase = (data) => {
  return post<any>(`/portal/customerDatabase`, data, {});
};

export const request_renameCustomerDatabase = (data) => {
  return post<any>(`/portal/customerDatabase/checkName`, data, {});
};

export const request_CustomerDatabaseName = (customerDBUuid) => {
  return get<any>(`/portal/customerDatabase/${customerDBUuid}/name`, {});
};
